import Fetch from "utils/fetch";

export const LOCATION_OPTION_TYPES = {
  SUPPLIER: 1,
  SUPPLIER_ORIGIN: 2,
  PLANT: 3,
  CONSIGNEE_STOCK_SUPPLIER: 4,
} as const;

export type LocationOptionDto = {
  type: number;
  referenceId: string | number;
  code?: string | null;
  description?: string | null;
  customerCode?: string | null;
  isSelectable?: boolean;
};

type LocationOptionApiDto = {
  Type?: number;
  ReferenceId?: string | number;
  Code?: string | null;
  Description?: string | null;
  CustomerCode?: string | null;
  IsSelectable?: boolean;
};

type LocationOptionsRequest = {
  supplierId?: string | number | null;
  labeledFamilyCenterId?: string | number | null;
  materialId?: string | number | null;
};

const hasIdentifier = (value: string | number | null | undefined): value is string | number =>
  value !== undefined && value !== null && value !== "" && String(value) !== "0";

const getOptions = (data: unknown): LocationOptionDto[] =>
  Array.isArray(data)
    ? (data as Array<LocationOptionDto & LocationOptionApiDto>)
        .filter(
          (option) =>
            typeof (option.type ?? option.Type) === "number" &&
            hasIdentifier(option.referenceId ?? option.ReferenceId)
        )
        .map((option) => ({
          type: option.type ?? option.Type ?? 0,
          referenceId: option.referenceId ?? option.ReferenceId ?? "",
          code: option.code ?? option.Code,
          description: option.description ?? option.Description,
          customerCode: option.customerCode ?? option.CustomerCode,
          isSelectable: option.isSelectable ?? option.IsSelectable,
        }))
    : [];

const getCreationPath = (location: "pick-up" | "delivery", query: string) =>
  `/suggestions/location-options/${location}?${query}&useFilterDefault=false`;

export const fetchPickUpLocationOptions = async ({
  supplierId,
}: LocationOptionsRequest = {}): Promise<LocationOptionDto[]> => {
  if (!hasIdentifier(supplierId)) return [];

  const { data } = await Fetch.get(
    getCreationPath("pick-up", `supplierId=${encodeURIComponent(String(supplierId))}`)
  );
  return getOptions(data);
};

export const fetchDeliveryLocationOptions = async ({
  labeledFamilyCenterId,
  materialId,
}: LocationOptionsRequest = {}): Promise<LocationOptionDto[]> => {
  if (!hasIdentifier(labeledFamilyCenterId) || !hasIdentifier(materialId)) return [];

  const { data } = await Fetch.get(
    getCreationPath(
      "delivery",
      `labeledFamilyCenterId=${encodeURIComponent(String(labeledFamilyCenterId))}&materialId=${encodeURIComponent(String(materialId))}`
    )
  );
  return getOptions(data);
};
